import { FeatureState, LoadingState } from '../models'

import { FeatureActionTypes } from './actionTypes'

const initState: FeatureState = {
  loading: LoadingState.WAITING,
  features: {}
}

export function featuresReducer(state = initState, { type, payload }): FeatureState {
  switch (type) {
    case FeatureActionTypes.GET_FEATURES:
      return { ...state, loading: LoadingState.LOADING }
    case FeatureActionTypes.GET_FEATURES_ERROR:
      return { ...state, loading: LoadingState.ERROR }
    case FeatureActionTypes.GET_FEATURES_SUCCESS:
      return {
        ...state,
        loading: LoadingState.SUCCESS,
        features: payload
      }
    default:
      return state
  }
}
